import React from 'react';
import type { V2Guard, V2Route } from '../units/types';

const ChatV2Page = React.lazy(() => import('./ChatV2Page'));
/** 旧 /chat-v2 と同じく組織の enable_chat_tools */
const guard: V2Guard = { kind: 'feature', feature: 'enable_chat_tools' };

/** この担当が新UIで作り直した画面の経路（旧 /chat-v2・/chat-v2/:chatId）。/chat-v2/edit/:editId は recipe の担当 */
const routes: V2Route[] = [
  { path: 'chat-v2', Component: ChatV2Page, guard },
  { path: 'chat-v2/:chatId', Component: ChatV2Page, guard },
];

export default routes;
